import { z } from 'zod';
import { assetClass } from '@garnet/domain';
/**
 * Per-vertical configuration (Garnet PRD §38): one screen and component layer serves
 * every asset class; a vertical is a CONFIG plus a dataset, never a code fork. No string
 * unique to a vertical may be hard-coded in a screen — acceptance §38.1 is tested by the
 * vertical-addition diff at the Phase 6 gate.
 */
export const verticalConfig = z.object({
    vertical: assetClass,
    display_name: z.string(),
    identity: z.object({
        /** e.g. UDI-DI for medical, e-mark/part number for automotive. */
        identifier_label: z.string(),
        identifier_kinds: z.array(z.string()).min(1),
        carrier: z.enum(['gs1_datamatrix', 'gs1_128', 'qr', 'none']),
        parse_hint: z.string(),
    }),
    upload: z.object({
        document_labels: z.array(z.string()).min(1),
        baseline_documents: z.array(z.string()),
    }),
    decision_wording: z.object({
        qualify: z.string(),
        qualify_with_conditions: z.string(),
        block: z.string(),
    }),
    portal_copy: z.object({
        invitation_heading: z.string(),
        submit_heading: z.string(),
    }),
    connector_set: z.array(z.string()).min(1),
    classification: z.object({
        /** Garnet Core domain this vertical classifies under. */
        core_domain: z.string(),
        rule_set_hint: z.string(),
    }),
    design_examples: z.object({
        asset_example: z.string(),
        regulation_examples: z.array(z.string()),
    }),
});
//# sourceMappingURL=vertical-config.js.map